<div appTheme>
    <div class="modal-box scrolling">
        <div class="modal-box-container main-container">
            <h1>Confirm Registration</h1>
            <div class="col-sm-12">
                <div *ngIf="!failureMessage">
                    <p>Press the button below to complete your registration.</p>
                    <br><br>
                    <button class="submit-button button-large" id="validateBtn" (click)="onValidateUser()">
                        Complete Registration <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
                <br>
                <br>
                <span class="success-message" *ngIf="successMessage.length > 0">{{successMessage}}</span>
                <span class="failure-message" *ngIf="failureMessage.length > 0">
                <p>{{failureMessage}}
                <p>If you have already completed registration, you may <a (click)="goToLogin()">Sign In </a>.</p>
                <p>Or enter your email address below to send the validation email again.</p>
            </span>
                <div *ngIf="failureMessage">
                    <form (ngSubmit)=resendValidationEmail(f) #f="ngForm">
                        <span class="error-text">{{error}}</span>
                        <input
                            class="input-text"
                            type="email"
                            name="validationEmail"
                            [ngModel]="validationEmail"
                            placeholder="Email"
                            validationEmail
                            required
                            maxlength="50"
                            #validationEmailRef="ngModel"
                            pattern="[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}"
                        />
                        <span class="help-block" *ngIf="!validationEmailRef.valid && validationEmailRef.touched">Please enter a valid email.</span>
                        <div class="bottom">
                            <button class="submit-button button-large" id="resendBtn"
                            [disabled]="!validationEmailRef.valid">
                                Re-send Validation email <i class="fa fa-arrow-right" aria-hidden="true"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Completing Registration...'" [size]="'fa-5x'"></app-loading>
</div>
